import React from "react";
import { Popover, Button, Radio } from "antd";
import { observer } from "mobx-react";
import { translateKey as t } from "../../../locales/translation";
import { observable } from "mobx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";

@observer
export class StateFilter extends React.PureComponent<{
  column: any;
  structure: any;
  handleFilter?: any;
}> {
  @observable private isMenuShowing = false;

  private renderResetBtn = () => {
    const { column } = this.props;

    return (
      <Button
        data-e2e={"state-filter-reset-button"}
        size="small"
        disabled={column.filterValue === "" && column.finalFilterValue === ""}
        onClick={() => {
          column.filterValue = "";
          this.props.handleFilter(column, "");
          this.isMenuShowing = false;
        }}
      >
        {t("lblReset", "Reset")}
      </Button>
    );
  };

  private handleValueChange = (column, value) => {
    column.filterValue = value;
    this.props.handleFilter(column, "state");

    if (column.filterOnSubmit) {
      this.isMenuShowing = false;
    }
  };

  private getValues = (structure) => {
    const elements = [];

    structure.forEach((val, i) => {
      elements.push(
        <Radio style={{ display: "block", marginTop: "5px" }} value={val.value} key={i}>
          {val.title}
        </Radio>
      );
    });

    return elements;
  };

  public render() {
    const { column, structure } = this.props;

    const content = (
      <Radio.Group onChange={(e) => this.handleValueChange(column, e.target.value)} value={column.filterValue}>
        <Radio style={{ display: "block" }} value="" key="all">
          {t("lblShowAll", "Show All")}
        </Radio>
        {this.getValues(structure)}
      </Radio.Group>
    );

    return (
      <Popover
        placement="bottom"
        content={content}
        trigger="click"
        title={this.renderResetBtn()}
        open={this.isMenuShowing}
        onOpenChange={(val) => {
          this.isMenuShowing = val;
        }}
      >
        <Button size="small" style={{ width: "100%" }}>
          {this.props.column.filterValue !== "" ? (
            <FontAwesomeIcon icon={faFilter} style={{ color: "#1890ff" }} />
          ) : (
            <FontAwesomeIcon icon={faFilter} />
          )}
        </Button>
      </Popover>
    );
  }
}
